import React from 'react';
import { observer } from 'mobx-react';
import {
  BoosterDtoTypeEnum, CampaignConfigDto, DiscountDto,
} from '@coretava/api/ecommerce-service';
import BasicCampaignHeader from './basic/BasicCampaignHeader';
import ReferralCampaignHeader from './referral/ReferralCampaignHeader';
import SurveyCampaignHeader from './survey/SurveyCampaignHeader';
import WheelCampaignHeader from './wheel/WheelCampaignHeader';

const CampaignHeader: React.FC<{ campaign: CampaignConfigDto, discount?: DiscountDto }> = ({ campaign, discount }) => React.useMemo(() => {
  switch (campaign.booster?.type) {
    case BoosterDtoTypeEnum.Basic:
      return <BasicCampaignHeader discount={discount} campaign={campaign} />;
    case BoosterDtoTypeEnum.Referal:
      return <ReferralCampaignHeader />;
    case BoosterDtoTypeEnum.Survey:
      return <SurveyCampaignHeader />;
    case BoosterDtoTypeEnum.Wheel:
      return <WheelCampaignHeader />;
    default:
      return undefined;
  }
}, [campaign, discount]);

export default observer(CampaignHeader);
